import { StyleSheet } from 'react-native';
import { WARMUP_COLORS } from '../../../src/quiz/constants/warmup.constants';

export const warmupScreenStyles = StyleSheet.create({
  root: {
    flex: 1,
    backgroundColor: WARMUP_COLORS.bg,
    alignItems: 'center',
  },
  // Fullscreen game takeover: fills the whole screen with no header, top inset, or width cap so
  // the game (which rotates to landscape on portrait phones) is never offset or clipped by chrome.
  fullscreenRoot: {
    flex: 1,
    backgroundColor: WARMUP_COLORS.bg,
  },
  // Keeps the game a phone-width column so it stays centered (not stretched) on tablet / desktop web.
  column: {
    flex: 1,
    width: '100%',
    maxWidth: 500,
    position: 'relative',
  },
  body: {
    flex: 1,
  },
  centered: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
    gap: 14,
  },
  message: {
    color: WARMUP_COLORS.textDim,
    fontSize: 15,
    textAlign: 'center',
  },
  retryButton: {
    backgroundColor: WARMUP_COLORS.purple,
    borderRadius: 9999,
    paddingVertical: 10,
    paddingHorizontal: 22,
  },
  retryText: {
    color: WARMUP_COLORS.textOnBright,
    fontWeight: '800',
    fontSize: 14,
  },
  pressed: {
    opacity: 0.85,
  },
});
